module.exports = __webpack_public_path__ + "static/media/AWS_contentsPage_ko.e4efd247.png";